var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MDCChip } from '@material/chips/chip';
import { strings } from '@material/chips/chip/constants';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import withRender from './Chip.html';
const EVENT_CHIP_CLEAR = 'dismiss';
const EVENT_CHIP_INTERACTION = 'interaction';
const EVENT_CHIP_TRAILING_ICON_CLICKED = 'interaction-trailing-icon';
let Chip = class Chip extends Vue {
    /**
     * Hook called after the initial render.
     * This has full access to the reactive component, templates, and rendered DOM.
     */
    mounted() {
        const vm = this;
        const el = vm.$el;
        const chip = this.chip = new MDCChip(el);
        chip.shouldRemoveOnTrailingIconClick = false;
        chip.listen(strings.TRAILING_ICON_INTERACTION_EVENT, ($event) => {
            const eventName = this.$refs.trailingIcon ? EVENT_CHIP_CLEAR : EVENT_CHIP_TRAILING_ICON_CLICKED;
            vm.$emit(eventName, this);
        });
        chip.listen(strings.INTERACTION_EVENT, () => {
            vm.$emit(EVENT_CHIP_INTERACTION);
        });
    }
    beforeDestroy() {
        this.chip.destroy();
    }
    destroyChip() {
        this.chip.beginExit();
        this.chip.destroy();
    }
};
Chip = __decorate([
    withRender,
    Component
], Chip);
export default Chip;
//# sourceMappingURL=Chip.js.map